import React from "react";
import { Field } from 'redux-form/immutable';
import { SelectField } from 'redux-form-antd';
import {
    required, nullValue0
} from '../../validDesc';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
}

const ClubWednesdaySelect = props => {
    const club_monday_select = [
        {
            label: '-- 請選擇 --',
            value: '0'
        },
        {
            value: '339',
            label: '4:50自接'
        },
        {
            value: '300',
            label: '安親1-2年級'
        },
        {
            value: '320',
            label: '足球1-3年級'
        },
        {
            value: '329',
            label: '圍棋'
        },
        {
            value: '330',
            label: '英文閱讀領袖班1年級'
        },
        {
            value: '332',
            label: '美術初階1-2年級—【我是創意小玩家】'
        },
        {
            value: '333',
            label: '陶藝—【立體雕塑班】'
        },
        {
            value: '334',
            label: '日語進階—【日語會話】'
        },
        {
            value: '337',
            label: '鋼琴'
        },
        {
            value: '338',
            label: '小提琴'
        },
    ]
    const club_wednesday_display_options = club_monday_select.map(item => (
        item.value === '0' ? item : { ...item, label: `[${item.value}]${item.label}` }
    ));
    return (
        <div>
             <Field {...formItemLayout} validate={[required, nullValue0]} component={SelectField} label="星期三"
                options={club_wednesday_display_options} name="club_wednesday" type="text"></Field>
        </div>
    )
}

export default ClubWednesdaySelect



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/StudentClubForm/ClubWednesdaySelect.jsx